import { loadTheme, OurBrands } from '@sial/common-design'
import { getBrandIdentity } from '@src/utils/getBrandIdentity'

// Temporary import for Lato Sans to Lato font replacements.
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const brandIdentity = getBrandIdentity()

export const theme = loadTheme(
  OurBrands[brandIdentity],
  featureFlags.replaceLatoWithNoto
)
